import { useState } from "react";
import { apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function EditOrgModal({ orgToEdit, onClose, onUpdated, canSetPayment }) {
  const [name, setName] = useState(orgToEdit.name);
  const [siret, setSiret] = useState(orgToEdit.siret || "");
  const [paymentDefault, setPaymentDefault] = useState(!!orgToEdit.payment_default);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Champ envoyé par les seuls admins : le backend rejette la requête
      // entière si un autre rôle tente de le modifier.
      const body = canSetPayment
        ? { name, payment_default: paymentDefault, siret: siret.trim() || null }
        : { name, siret: siret.trim() || null };
      await apiSend(`/api/organizations/${orgToEdit.id}`, "PUT", body,
        "Erreur lors de la modification");
      onUpdated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la modification"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Modifier l'organisation</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          <label>Nom de l'organisation</label>
          <input value={name} onChange={(e) => setName(e.target.value)} required />
          <label>SIRET</label>
          <input
            value={siret}
            onChange={(e) => setSiret(e.target.value)}
            inputMode="numeric"
            placeholder="123 456 789 00012"
            maxLength={20}
          />
          {canSetPayment && (
            <label className="modal-check">
              <input
                type="checkbox"
                checked={paymentDefault}
                onChange={(e) => setPaymentDefault(e.target.checked)}
              />
              En défaut de paiement — ses QR passent à « Inactif »
            </label>
          )}
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Modification..." : "Enregistrer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditOrgModal;
